package songwritersnotebook.app.utils

import androidx.compose.runtime.Composable

@Composable
actual fun rememberMicPermissionLauncher(
    onGranted: () -> Unit,
    onDenied: () -> Unit
): () -> Unit {
    return { onGranted() }
}

@Composable
actual fun rememberNotificationPermissionLauncher(
    onGranted: () -> Unit,
    onDenied: () -> Unit
): () -> Unit {
    return { onGranted() }
}
